import AnnouncementsService from "@app/services/announcements";

const announcementStore = {
  namespaced: true,
  state: {
    list: [],
  },
  getters: {
    list(state) {
      return state.list;
    },
  },
  mutations: {
    setList(state, payload) {
      state.list = payload;
    },
  },
  actions: {
    async getList({ commit }) {
      try {
        const announcementList = await AnnouncementsService.announcements();
        commit("setList", announcementList);
      } catch (error) {
        console.error(error);
      } finally {
        return;
      }
    },
  }
};

export default announcementStore;
